// extracted by mini-css-extract-plugin
export default {"loader":"MainLoader_loader__+CoMb","l11":"MainLoader_l11__uVPEO"};